import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  kjdw: {
    title: '空间定位',
    dec: '记录与计算相机在拍摄时的空间位置，并提取对应的3D点云，从而<br/>获取三维空间的真实情况。',
    points: [
      {
        posi: {
          top: '33%',
          left: '27%'
        }
      },
      {
        posi: {
          top: '20%',
          left: '50%'
        }
      },
      {
        posi: {
          top: '27%',
          left: '57%'
        }
      },
      {
        posi: {
          top: '38%',
          left: '47%'
        }
      },
      {
        posi: {
          top: '60%',
          left: '50%'
        }
      },
      {
        posi: {
          top: '63%',
          left: '63%'
        }
      },
      {
        posi: {
          top: '74%',
          left: '82%'
        }
      }
    ],
    ability: {
      name: 'AI数字化算法的创新技术能力',
      sub: '全新算法极大提升了关键帧特征点的匹配准确率，把定位丢失的情况降至最低。<br/>另外，基于自适应分段的集束调整，把长序列分成若干序列在后端优化，<br/>改善了优化效率。',
      app: [
        {
          icon: {
            backgroundImage: `url(${baseUrl}images/img_core_app011.png)`
          },
          sub: 'AI空间重构算法'
        },
        {
          icon: {
            backgroundImage: `url(${baseUrl}images/img_core_app022.png)`
          },
          sub: 'AI相机位姿计算'
        },
        {
          icon: {
            backgroundImage: `url(${baseUrl}images/img_core_app033.png)`
          },
          sub: 'AI空间几何校准'
        }
      ]
    }
  },
  kjjm: {
    title: '空间重建',
    dec: '基于空间定位的3D点云，自动化进行高精度三维数字化重建，还原空间的平面布局及三维结构。',
    logon: '自动化高精度三维数字重建技术<br/>在获取稀疏点云和相机位姿后，计算空间的平面布局并恢复三维结构，生成3D场景。',
    chars: [
      {
        icon: {
          backgroundImage: `url(${baseUrl}images/img_core_model01.png)`
        },
        title: '生理结构',
        sub:
          '输入稀疏点云和相机位姿<br/>数据，计算自由空间和核心自由空间。'
      },
      {
        icon: {
          backgroundImage: `url(${baseUrl}images/img_core_model02.png)`
        },
        title: '生理结构',
        sub: '两次解决最短<br/>路径问题以恢复细结构。'
      },
      {
        icon: {
          backgroundImage: `url(${baseUrl}images/img_core_model03.png)`
        },
        title: '生理结构',
        sub: '基于计算出的平面图，<br/>生成网格结构和3D空间。'
      }
    ]
  },
  kjzs: {
    title: '空间展示',
    sub: '计算生成的结果通过WebGL呈现交互式3D空间，空间中可添加图文、视频、音频、超链接等多种媒体格式，<br/>并可显示测距信息，或者制定自动导览，通过数字三维空间承载丰富的信息。',
    sdkz: {
      name: '在线漫游博物馆 - 四维看展',
      sub: '四维看展是国内首家集文字、图片、语音、在线场景漫游于一体的线上艺术空间。打开小程序即可浏览全球最新最全的艺术资讯，实时了解最热门的文博动态，让您足不出户就能逛遍全球精彩展览，720°轻松鉴赏艺术作品，是一座永不落幕的美术馆。'
    },
    zfb: {
      name: '3D实景看房 - 指房宝',
      sub: '指房宝平台是针对房产中介、装修企业的需求，基于四维看看进行定制的软硬件一体化产品，包括定制化的3D相机、移动端3D空间编辑软件及移动端3D房源展示交易平台，开创了全新的数字3D实景房产交易体验，应用于租房、买房、装修建房等多样的业务场景。'
    }
  },
  jianrong: {
    name: '兼容多平台、多终端',
    sub: '无需插件，可在手机、 平板、PC端、VR眼镜，实现720°沉浸式漫游体验。',
    terminal: [
      {
        txt: 'VR端',
        img: baseUrl + 'images/img_core_platform_vr.png'
      },
      {
        txt: '网页端',
        img: baseUrl + 'images/img_core_platform_pc.png'
      },
      {
        txt: '移动端',
        img: baseUrl + 'images/img_core_platform_phone.png'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/store/language/cn/coreTech.js